function validateFields(values, fields) {
  return fields.filter((key) => !values?.[key] || values[key] === "");
}

export const checkFormFields = (values, requiredFields) => {
 
  const errors = validateFields(values, requiredFields);
  return errors;
};
